<template>
  <PartialRenderer :items="printers" force-render-items="3" v-slot="{item, index}">
    <div :class="className">
      <printer-item :printer="item"></printer-item>
    </div>
  </PartialRenderer>
</template>

<script>
  import PartialRenderer from '../PartialRenderer';
  import PrinterItem from './PrinterItem';

  export default {
    name: 'printers-list',
    props: {
      printers: {
        type: Array
      },
      grouped: {
        type: Boolean,
        default: false
      }
    },
    components: {
      PartialRenderer,
      PrinterItem
    },

    computed: {
      className() {
        return !this.grouped ? 'table table--files table--jobs only-printers' : '';
      }
    }
  }
</script>
